import React from 'react';
import { useModal } from '../../../shared/hooks/dashboardHooks';
import WidgetFiltersModal from '../../../shared/filtering/WidgetFiltersModal';

export default function WidgetActionsMenu(props) {
    const [isFiltersModalVisible, closeFiltersModal, showFiltersModal] =
        useModal();

    return (
        <>
            <span
                className="widget-action-icon fa fa-filter"
                onClick={showFiltersModal}
            />
            {isFiltersModalVisible && (
                <WidgetFiltersModal closeModal={closeFiltersModal} {...props} />
            )}
        </>
    );
}
